export const DEBOUNCE_TIMERS = {
  GLOBAL_SEARCH: 250,
  LEAGUE_SEARCH_DELAY: 300,
  SHIPMENT_SUGGESTION: 300,
}

/**
 * This timer is used to delay the rendering of certain components during SSR to prevent hydration mismatches. The value is set to 1500ms to allow enough time for the necessary data to be fetched and rendered on the server before the client attempts to hydrate the component.
 */
export const SSR_RENDERING_DELAY = 1500

/**
 * This timer is used to control the duration of the initial loading state in the HotelResult component. It is set to 2500ms to provide a smooth user experience while the hotel data is being fetched and processed. After this duration, the initial loader will be hidden, allowing users to see the hotel results or any relevant messages if no hotels are found.
 */
export const FULLSCREEN_LOADER_TIMING = {
  HOTEL_LIST: 3000,
  HOTEL_DETAILS: 3000,
  FLIGHT_LIST: 3500,
}
